import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./homeSection.css";

const Catalogo = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate(); // Hook de navegación

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible"); // Activa la animación
          } else {
            entry.target.classList.remove("visible"); // Reinicia la animación
          }
        });
      },
      { threshold: 0.1 } // Se activa cuando el 10% del componente es visible
    );

    const element = containerRef.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element); // Limpieza del observador
      }
    };
  }, []);

  const handleNavigate = () => {
    navigate("/catalogo"); // Navega a la sección /catalogo
  };

  return (
    <div className="home-section home-section--blue" id="about" ref={containerRef}>
      <div className="home-section__container">
        <div className="home-section__text text-side">
          <h2 className="home-section__heading">Catálogo</h2>
          <p className="home-section__description">
            ¡Descubrí nuestro <span className="home-section__highlight">catálogo</span>
            <br />
            completo de componentes electrónicos!
          </p>
          <p className="home-section__description">
            Filtrá por categorías para recorrer
            <span className="home-section__highlight"> con facilidad </span>
            <br />
            nuestra amplia variedad de productos
          </p>
          <button className="home-section__cta" onClick={handleNavigate}>
            Ver catálogo
          </button>
        </div>
        <div className="home-section__frame image-side">
          <img src={"/images/R4.png"} alt="catalogo" />
        </div>
      </div>
    </div>
  );
};

export default Catalogo;
